// http://jsonapi.org/format/#error-objects
// Most of the time the api returns errors in the JSON api spec

// * title
// A short, human-readable summary of the problem that SHOULD NOT change from occurrence to occurrence of the problem, except for purposes of localization.

// * detail
// A human-readable explanation specific to this occurrence of the problem. Like title, this field’s value can be localized.

// * source
// An object containing references to the source of the error, optionally including any of the following members:

import { keysToSnakeCase } from '@myxplor/payload-helpers'

export const extractReasons = (errors = []) => {
  const summary = extractSummary(errors)

  if (summary.length === 0) {
    return unKnownErrors(errors)
  }

  let payload = {}
  errors.forEach(err => {
    payload = Object.assign({}, extractReason(err.source, payload))
  })

  payload.summary = extractSummary(errors)

  return keysToSnakeCase(payload)
}

const extractSummary = (errors = []) => {
  let output = []
  errors.forEach(error => {
    switch (true) {
    case typeof error === 'string':
      output.push(error)
      break

    case error.__exception__:
      output.push(`Exception: ${error.reason}`)
      break

    default:
      output.push(error.title, error.detail, error.reason)
      break
    }
  })

  return output.filter(err => err)
}

const extractReason = (err, payload) => {
  for (let key in err) {
    if (err.hasOwnProperty(key) && key !== 'resource') {
      if (hasNestedErrors(err[key])) {
        payload[key] = err[key]
      } else {
        payload[key] = (payload[key] || []).concat([err[key]])
      }
    }
  }

  return payload
}

export const hasNestedErrors = error => error && error.constructor === Object

const unKnownErrors = (errors = []) => {
  let payload = {}
  errors.forEach(err => {
    payload = Object.assign({}, extractReason(err, payload))
  })

  payload.summary = ['Unknown error']
  return payload
}



// WEBPACK FOOTER //
// ./src/io/error-handling/json-api.js